<template>
  <v-card flat class="pa-5">
      <div v-if="$route.params.tipo != 'DePara'">
        <v-row class="flex-busqueda">
          <v-col cols="12" sm="6" md="7" class="grid-title">
            <div>
              <h1 class="title-entrantes">Oficios {{$route.params.tipo}}</h1>
            </div>
          </v-col>
          <v-col cols="10" sm="5" md="4">
            <v-text-field v-model="search" @keydown.enter="onSearchSubmit()" append-icon="mdi-magnify" single-line dense :label="$route.params.tipo === 'Entrantes' ? 'Buscar por número, para o asunto' : 'Buscar por número, generó, para o asunto'"  ref="textFocus">
            </v-text-field>
          </v-col>
          <v-col cols="2" sm="1" md="1">
            <v-icon @click="focusTextField" class="btn ml-3">mdi-cog</v-icon>
          </v-col>
        </v-row>
      </div>
    <v-alert v-if="$route.params.tipo != 'DePara'" color="rgb(256, 256, 256)" transition="scroll-y-transition" v-show="busquedaAvanzada"
        class="v-alert-class">
        <p class="busqueda-title">Busqueda Avanzada</p>
        <v-row class="v-alert-flex">
          <v-col cols="auto">
             <v-checkbox color="rgb(84, 110, 122)" label="Busqueda por palabras" v-model="tipo"></v-checkbox> 
          </v-col>
          <v-col cols="auto">
            <!-- <span class="subtitle-2 grey--text text--darken-1">Buscar en</span> -->
            <v-radio-group row v-model="filter" >
               <v-radio color="rgb(84, 110, 122)" label="Todo" :value="0"></v-radio>
                <v-radio color="rgb(84, 110, 122)" label="Número" :value="1"></v-radio>
                <v-radio  color="rgb(84, 110, 122)" label="Para" :value="2"></v-radio>
                <v-radio color="rgb(84, 110, 122)"  :value="3" label="Asunto"></v-radio>
                <v-radio color="rgb(84, 110, 122)"  v-if="$route.params.tipo=='Generados'" :value="4" label="Generó"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="auto" class="btn-group">
            <v-btn small plain @click="cancelarBusqueda()">Cancelar</v-btn>
            <v-btn small dark color="rgb(84, 110, 122)" @click="onSearchSubmit()">Aplicar Filtros</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    <div>
      <v-card-actions class="px-4 pt-4" v-if="$route.params.tipo=='Entrantes'">
        <nuevo-oficio-entrante v-if="agregarEntrante" :mostrar="agregarEntrante" :relacionado="false"
          :ultimaEntidad="ultimaEntidad" @cancelar="agregarEntrante = false" @oficioGuardado="agregarEntrante = false; fetchOficios()" />
        <v-btn small color="blue-grey" dark @click="agregarEntrante = true">Nuevo oficio entrante</v-btn>
      </v-card-actions>
      <v-row v-if="$route.params.tipo=='Generados'">
        <v-card-actions>
          <v-row>
            <v-col cols="auto">
              <v-btn small color="blue-grey" dark @click="agregarGenerado = true">Generar oficio</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn small color="blue-grey" dark @click="mostrarConsecutivo=true">Consultar consecutivo</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn v-if="this.role === 'admin' || this.role === 'super-admin'" small color="blue-grey" dark @click="crearReporte = true" >Generar reporte por fecha de captura<v-icon right dark>mdi-file</v-icon></v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn v-if="this.role === 'admin'|| this.role === 'super-admin'" small color="blue-grey" dark @click="crearReporte2 = true" >Generar reporte por número de mes<v-icon right dark>mdi-file</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-row>

      
    </div>
      


    <v-data-table v-if="$route.params.tipo === 'Entrantes'" :headers="headersEntrantes" :items="oficios"
      :loading="loading" loading-text="Cargando Oficios..." no-data-text="No hay oficios para mostrar."
      :items-per-page="10" class="elevation-1 mb-5 mt-10" hide-default-footer>
        <template v-slot:[`item.relacionado`]="{ item }" >
          <v-tooltip v-if="item.relacionado.id" right>
              <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-reply-outline</v-icon>
              </template>
              <span>Oficio de respuesta</span>
          </v-tooltip>
      </template>
      <template v-slot:[`item.numero`]="{ item }">
        <router-link
          :to="{ name: 'Consultar oficio', params: item.relacionado.id ? { tipo: item.relacionado.tipo, id: item.relacionado.id } : { tipo: 'entrante', id: item._id } }"><span
            v-html="item.numero"></span></router-link>
      </template>
      <template v-slot:[`item.para`]="{ item }">
        <span v-if="item.destinatario.usuario">{{ item.destinatario.usuario.titulo }} <span
            v-html="item.destinatario.usuario.nombreCompleto"></span></span>
      </template>
      <template v-slot:[`item.documento`]="{ item }">
        <v-icon :color="fileColor(item.files)">mdi-file-{{ fileChecker(item.files) }}</v-icon>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ showDate(item.fecha) }}
      </template>
      <template v-slot:[`item.recepcion`]="{ item }">
        {{ showDate(item.recepcion) }}
      </template>
      <template v-slot:[`item.asunto`]="{ item }">
        <!-- <span v-html="truncarAsunto(item.asunto, search)"></span> -->
        <span v-html="item.asunto"></span>
      </template>
    </v-data-table>
    <v-data-table v-if="$route.params.tipo == 'Generados'" :headers="headersGenerados" :items="oficios" :loading="loading"
      loading-text="Cargando Oficios..." no-data-text="No hay oficios para mostrar." :items-per-page="10"
      class="elevation-1 mb-5 mt-10" hide-default-footer>
      <template v-slot:[`item.relacionado`]="{ item }">
          <v-tooltip v-if="item.relacionado.id" right>
              <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-reply-outline</v-icon>
              </template>
              <span>Oficio de respuesta</span>
          </v-tooltip>
      </template>
      <template v-slot:[`item.numeroCompleto`]="{ item }">
        <router-link
          :to="{ name: 'Consultar oficio', params: item.relacionado.id ? { tipo: item.relacionado.tipo, id: item.relacionado.id } : { tipo: 'generado', id: item._id } }"><span
            v-html="item.numeroCompleto"></span></router-link>
      </template>
      <template v-slot:[`item.asunto`]="{ item }">
        <span v-html="item.asunto"></span>
        <!-- <span v-html="truncarAsunto(item.asunto, search)"></span> -->
      </template>
      <template v-slot:[`item.documento`]="{ item }">
        <v-icon :color="fileColor(item.files)">mdi-file-{{ fileChecker(item.files) }}</v-icon>
      </template>
      <template v-slot:[`item.para`]="{ item }">
        <span v-html="item.destinatario.responsable"></span>
      </template>
      <template v-slot:[`item.genero`]="{ item }">
        <span v-if="item.emisor.usuario">{{ item.emisor.usuario.titulo }} <span
            v-html="item.emisor.usuario.nombreCompleto"></span></span>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ showDate(item.fecha) }}
      </template>
      <template v-slot:[`item.fechaRecibido`]="{ item }">
        {{ showDate(item.fechaRecibido) }}
      </template>
    </v-data-table>
    <div v-if="$route.params.tipo == 'DePara'">
        <ListadoDepara/>
    </div>
  
    <section v-if="$route.params.tipo != 'DePara'" class="d-flex justify-center align-center flex-column">
      
      <div class="d-flex">
        <v-pagination v-model="page" @input="onPageChange" :length="totalPages || 1" :total-visible="6"
          class="mr-2" color="blue-grey"></v-pagination>
        <v-select style="max-width: 175px;" @input="onSelectChange" :value="`Página ${page}`"
          :menu-props="{ top: true, offsetY: true }" :items="Array.from({ length: totalPages || 1 }, (_, i) => `Página ${i + 1}`)"
          hide-details outlined dense></v-select>
      </div>
      <span class="grey--text text-center">Mostrando {{ (page != totalPages && page < totalPages) ? page * 10 :
        totalOficios }} de {{ totalOficios }} oficios. </span>
    </section>
    <div style="padding:20px">
      <logs :logs="logs"></logs>
    </div>

    <consecutivos :mostrar="mostrarConsecutivo" @cancelar="mostrarConsecutivo=false"></consecutivos>
    <nuevo-oficio-generado
      v-if="agregarGenerado"
      :mostrar="agregarGenerado"
      :relacionado="false"
      @cancelar="agregarGenerado = false"
      @oficioGuardado="
        agregarGenerado = false;
        fetchOficios();
      "
    />
    <crearReporteGenerados
      v-if="crearReporte"
      :mostrar="crearReporte"
      :reporte="1"
      @cancelar="crearReporte = false"
    />
    <crearReporteGenerados
      v-if="crearReporte2"
      :mostrar="crearReporte2"
      :reporte="2"
      @cancelar="crearReporte2 = false"
    />
  </v-card>
</template>

<script>
import { cargarOficiosEntrantesService } from './oficiosEntrantes.service';
import { cargarOficiosGeneradosService } from './oficiosGenerados.service';
import { DateTime } from 'luxon';
import ListadoDepara from "../depara/listadoDepara.vue";
import nuevoOficioGenerado from "./nuevoOficioGenerado";
import nuevoOficioEntrante from "./nuevoOficioEntrante";
import consecutivos from "./consecutivos.vue"
import { mapGetters } from "vuex";
import crearReporteGenerados from "./crearReporteGenerados.vue";
import { getLogsOficios } from "../../components/logs/logs.service"
import Logs from "../logs/logs.vue"
export default {
  name: 'vistaOficios',
   computed: {
    ...mapGetters(["role"]),
  },
  components:{ ListadoDepara, nuevoOficioGenerado, nuevoOficioEntrante,consecutivos, crearReporteGenerados, Logs },
  data() {
    return {
      search: '',
      headersGenerados: [
        { text: '', value:'relacionado', sortable:false },
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Número', value: 'numeroCompleto', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Recepción', value: 'fechaRecibido', sortable: false },
        { text: 'Generó', value: 'genero', sortable: false },
        { text: 'Para', value: 'para', sortable: false },
        { text: 'Asunto', value: 'asunto', sortable: false },
      ],
      headersEntrantes: [
        { text: '', value:'relacionado', sortable:false },
        { text: 'Documento', value: 'documento', sortable: false },
        { text: 'Número', value: 'numero', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Tipo', value: 'tipoDocumento', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Recepción', value: 'recepcion', sortable: false },
        { text: 'Para', value: 'para', sortable: false },
        { text: 'Asunto', value: 'asunto', sortable: false },
      ],
      oficios: [],
      page: 1,
      totalPages: 1,
      totalOficios: 1,
      loading: false,
      filter:this.$route.query.filter,
      busquedaAvanzada: false,
      tipo:this.$route.query.words=='true'?true:false, // se refiere a la busqueda por palabras
      buscar:0,
      agregarEntrante:false,
      agregarGenerado:false,
      mostrarConsecutivo:false,
      ultimaEntidad: null,
      crearReporte:false,
      crearReporte2:false,
      logs:[]
    };
  },

  async mounted() {
    try {
          await this.fetchOficios();
          await this.getLogs()
        } catch (error) {
          this.$notify({
            title: 'Error',
            message: error.message,
            type: 'error',
          });
        }
  },

  watch: {
    async $route(x) {
      // console.log(x);
      this.tipo=(this.$route.query.words === 'true')? true:false 
      await this.fetchOficios();
    
    },
  },

  methods: {
    verifyQuery(query) {

      if (!query) return false;

      if (!Object.keys(query).includes('page') || !Object.keys(query).includes('search') || !Object.keys(query).includes('filter')) return false;

      if (isNaN(parseInt(query.page))) return false;

      if (isNaN(parseInt(query.filter)) || parseInt(query.filter) < 0 || parseInt(query.filter) > 4) return false;

      if (this.$route.params.tipo !== 'Entrantes' && this.$route.params.tipo !== 'Generados' && this.$route.params.tipo !== 'DePara') return false;

      return true;

    },
    toggleFilter(filter) {
      this.$router.replace({ query: { page: 1, search: this.search, filter, words:this.tipo } })
      .then(x=>{this.tipo=this.$route.query.words=='false'?false:true})
      .catch(err => {
        if (err.name != 'NavigationDuplicated') {
          // Maneja otros errores de navegación si es necesario
          console.error("verificar error");
        }
      });
    },
    onPageChange() {
      this.$router.replace({ query: { page: this.page, search: this.search, filter: this.filter, words:this.tipo } })
      .then(x=>{
          this.busquedaAvanzada=false,
        this.tipo=this.$route.query.words=='false'?false:true
        })
      .catch(err => {
        if (err.name != 'NavigationDuplicated') {
          // Maneja otros errores de navegación si es necesario
          console.error("verificar error");
        }
      });
    },
    onSelectChange(page) {
      this.$router.replace({ query: { page: page.split(' ')[1], search: this.search, filter: this.filter, words:this.tipo } })
      .then(x=>{this.tipo=this.$route.query.words=='false'?false:true})
      .catch(err => {
        if (err.name != 'NavigationDuplicated') {
          // Maneja otros errores de navegación si es necesario
          console.error("verificar error");
        }
      });
    },
    onSearchSubmit() {
      this.$router.replace({ query: { page: 1, search: this.search, filter: this.filter, words:this.tipo } })
      .then(x=>{this.tipo=this.$route.query.words=='false'?false:true})
      .catch(err => {
        if (err.name != 'NavigationDuplicated') {
          // Maneja otros errores de navegación si es necesario
          console.error("verificar error");
        }
      });
    },
    async fetchOficios() {
      try {
        this.loading = true;
        this.oficios = [];
        // console.log(this.$route.query);
        if (!this.verifyQuery(this.$route.query)) {
          this.$router.replace({ query: { page: 1, search: '', filter: 0, words:"false" }, params: { tipo: 'Entrantes' } });
          this.tipo=this.$route.query.words=='false'?false:true
        }
        this.page = parseInt(this.$route.query.page);
        // this.filter = this.busquedaAvanzada ? `${this.$route}`: parseInt(this.$route.query.filter);
        this.filter = parseInt(this.$route.query.filter);
        this.search = this.$route.query.search;

        const repoToUse = this.$route.params.tipo === 'Entrantes' ? cargarOficiosEntrantesService : cargarOficiosGeneradosService;
        const serverResponse = await repoToUse(this.page, this.search, this.filter, this.tipo);
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);

        if(this.filter!=0||this.tipo==true){this.busquedaAvanzada=true}
        if (serverResponse.paginas + 1 < this.page) {
          this.$router.replace({ query: { page: 1, search: this.search, filter:this.filter,words:this.tipo } });
          this.tipo=this.$route.query.words=='false'?false:true
        }
        if (this.oficios.length > 0 && this.$route.params.tipo === 'Entrantes') {
          this.ultimaEntidad = serverResponse.oficios[0].emisor.entidad;
        }
        this.oficios = serverResponse.oficios;
        this.totalPages = serverResponse.paginas;
        this.totalOficios = serverResponse.totalOficios;
        this.loading = false;
        this.logs=serverResponse.logs;
      } catch (error) {
        this.loading=false;
        this.$notificarError(error.message);
      }
    },
    showDate(date) {
      if (!date) return 'No capturada.';
      let dateObj = DateTime.fromSQL(date);
      if (!dateObj.isValid) dateObj = DateTime.fromSQL(date.split(' ')[0]);
      if (!dateObj.isValid) return 'No capturada.';
      return dateObj.toFormat('dd/MM/yyyy');
    },
    fileChecker(files) {
      if (!files.length) return 'cancel';
      for (const file of files) {
        if (file.type !== 'application/pdf') return 'alert';
      }
      return 'check';
    },
    fileColor(files) {
      if (!files.length) return 'error';
      for (const file of files) {
        if (file.type !== 'application/pdf') return 'warning';
      }
      return 'success';
    },
    focusTextField() {
        this.busquedaAvanzada= !this.busquedaAvanzada
      if (this.busquedaAvanzada) {
        this.$refs.textFocus.focus();
      }
      else {
        this.search = "";
        this.fetchOficios();
      }
    },
    cancelarBusqueda(){
        this.busquedaAvanzada=false,
        this.search = "";
        this.tipo=false

        this.$router.replace({ query: { page: this.page, search: this.search, filter: 0, words:"false" } }).catch(err => {
        if (err.name != 'NavigationDuplicated') {
          // Maneja otros errores de navegación si es necesario
          console.error("verificar error");
        }
      });
    },
    // async getLogs(){
    //   try{
    //     this.loading = true
    //     const serverResponse = await getLogsOficios(this.$route.params.tipo=='Entrantes'?'entrantes':'generados')
    //     // console.log(serverResponse);
    //     if(!serverResponse.ok) throw new Error(serverResponse.mensaje);
    //     // console.log(serverResponse);
    //     this.logs = serverResponse.logs;
    //   }catch(e){
    //       this.loading=false
    //       this.$notificarError(error);
    //   }

    // }
  
  },
};
</script>


<style>
.link {
  text-decoration: none;
}
.grid-entrante {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 4.5rem 1fr;
  grid-gap: 10px;
  align-items: center;
  padding: 0 1rem;
}
.grid-alerta {
  grid-column: 2/3;
  display: flex;
  justify-content: flex-end;
  border-radius: 0.2rem;
  position: relative;
  z-index: 1;
  left: 0;
  top: 0;
}
.grid-title {
  grid-row: 1/2;
  grid-column: 1/2;
}
.grid-busqueda {
  grid-column: 2/3;
  grid-row: 1/2;
  position: relative;
}
.flex-busqueda {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.title-entrantes {
  margin: 0;
  padding: 0;
  font-size: 1.8rem;
  font-weight: bold;
  letter-spacing: -1px;
  color: #444;
  font-family: Helvetica, Arial, sans-serif;
}

.btn:active {
  animation: cogMove 1s;
}

@keyframes cogMove {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.sys-bar {
  border-radius: 0.2rem 0.2rem 0 0;
}

.checkbox-label {
  font-size: 0.9rem;
  font-family: Helvetica, Arial, sans-serif;
  color: #333;
}
.v-alert-class {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) !important;
  grid-column: 1/3;
  grid-row: 2/3;
}
.btn-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.busqueda-title {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: -0.5px;
  color: #666;
  font-family: Helvetica, Arial, sans-serif;
}
.v-alert-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-center;
  justify-content: space-between;
}
</style>
x